module.exports = __webpack_public_path__ + "img/java_do_not_copy_eir_copy.dd718c18.png";